import classNames from 'classnames'
import Image, { StaticImageData } from 'next/image'
import classes from 'onboarding.module.sass'
import { ContainerElement } from 'types'

interface Props extends ContainerElement {
  desktopImg: StaticImageData
  mobileImg?: StaticImageData
}

export function OnboardingScreen({
  desktopImg,
  mobileImg,
  children,
  className,
}: Props) {
  return (
    <div className='flex h-screen w-full sm:w-[calc(100%-4rem)] flex-col items-center justify-center'>
      <div
        className={classNames(
          'flex flex-col relative sm:grid h-full sm:max-h-[38rem] w-full sm:max-w-[43.75rem] sm:grid-cols-[43%,57%] items-center overflow-hidden rounded-lg sm:bg-cool-50',
          classes['onboarding-screen']
        )}
      >
        <div
          className={classNames('relative grid w-full', {
            'h-full max-h-[11.25rem]': Boolean(mobileImg),
            'sm:max-h-full sm:max-w-[18.75rem] sm:pb-[100%] sm:h-full':
              Boolean(desktopImg),
          })}
        >
          <Image
            src={desktopImg}
            alt='Onboarding screen'
            role='presentation'
            fill
            className='object-cover object-center hidden sm:block'
            quality={50}
            sizes='(max-width:639px) 0vw, 40vw'
            fetchPriority='high'
            loading='eager'
            placeholder='blur'
          />

          {mobileImg && (
            <Image
              src={mobileImg}
              alt='Onboarding screen'
              role='presentation'
              fill
              className='object-cover object-center sm:hidden'
              quality={90}
              sizes='(max-width:639px) 90vw, 0vw'
              fetchPriority='high'
              loading='eager'
              placeholder='blur'
            />
          )}
        </div>

        <div className='flex h-full flex-col overflow-hidden w-full'>
          {children}
        </div>
      </div>
    </div>
  )
}
